import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ClusterTabs, type ClusterTab } from "@/components/console/cluster-tabs";

// One surface for everything about the organisation itself (redesign route consolidation):
// Profile · People & roles · Plan & billing · eTIMS. Each tab keeps its own page component;
// the per-surface six-step pass slims their headers later.
const ORGANISATION_TABS: ClusterTab[] = [
  { label: "Profile", to: "/dashboard/organisation/profile" },
  { label: "People & roles", to: "/dashboard/organisation/people" },
  { label: "Plan & billing", to: "/dashboard/organisation/billing" },
  { label: "eTIMS", to: "/dashboard/organisation/etims" },
];

export const Route = createFileRoute("/(app)/dashboard/organisation")({
  component: () => (
    <div className="flex w-full flex-col gap-3">
      <ClusterTabs items={ORGANISATION_TABS} />
      <Outlet />
    </div>
  ),
});
